<script>
  export let profile = null;
  import ContentPage from "./ContentPage.svelte";
  import ContactContent from "./Content/ContactContent.svelte";
</script>

<ContentPage profile="{profile}" title="Contact" content="{ContactContent}" />
